import { Typography, useTheme } from "@material-ui/core";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { DescriptionTagsService } from "../../services/DescriptionTagsService";
import Authorize from "../Authorize";
import Filteration from "../Filteration/Filteration";
import { RUDTable } from "../Table/RUDTable";
import UserContext from "../UserContext";
import AddDescriptionTags from "./AddDescriptionTags";

const DescriptionTag = () => {
    const [descriptionTag, setdescriptionTagAdded] = useState(0);
    const [filter, setFilter] = useState({
        search: "",
    });
    const { user } = useContext(UserContext);
    const history = useHistory();

    const [clearFilters, setClearFilters] = useState(false);
    const theme = useTheme();

    const handleFilterClear = () => {
        setClearFilters(!clearFilters);
        setFilter({
            search: "",
        });
    };

    return (
        <>
            <Authorize
                opName="CREATE DESCRIPTION_TAGS"
                // fallback={
                //     <AuthorizeFallback message="You're not authorized to create a new employee" />
                // }
            >
                <AddDescriptionTags
                    setdescriptionTagAdded={setdescriptionTagAdded}
                />
            </Authorize>

            <RUDTable
                getter={(page, limit) =>
                    DescriptionTagsService.getDescriptionTags(page, limit, {
                        search: filter.search ? filter.search : null,

                        // role: filter.role ? filter.role : null,
                        // classroom: filter.classroom ? filter.classroom : null,
                    })
                }
                editor={DescriptionTagsService.updateDescriptionTags}
                deletor={(ids) =>
                    DescriptionTagsService.deleteDescriptionTags(ids[0] as any)
                }
                readables={{
                    id: "ID",
                    name: "Name",
                    _description: "Description",
                }}
                rowsPreprocessor={(r) => ({
                    ...r,
                    deletionId: r.id,
                    _description: r.description ? (
                        r.description
                    ) : (
                        <Typography style={{ color: theme.palette.divider }}>
                            N/A
                        </Typography>
                    ),
                    description: r.description,
                })}
                ops={{
                    read: "READ DESCRIPTION_TAGS",
                    edit: "EDIT DESCRIPTION_TAGS",
                    delete: "DELETE DESCRIPTION_TAGS",
                }}
                updatingAgents={[descriptionTag, filter.search]}
                editables={[
                    {
                        name: "name",
                        type: "textfield",
                        label: "Name",
                        isRequired: true,
                    },

                    {
                        name: "description",
                        type: "textfield",
                        label: "Description",
                        isRequired: false,
                    },
                ]}
                filters={
                    <Filteration
                        handleClear={handleFilterClear}
                        filter={filter}
                        setFilter={setFilter}
                    />
                }
                customCols={[]}
                storageKey="descriptionTags"
            />
        </>
    );
};

export default DescriptionTag;
